import { PickObjectPropertiesHelperBase } from './PickObjectPropertiesHelperBase';
export class PickPropertyObjectPropertiesHelper extends PickObjectPropertiesHelperBase {
    getObjectProperty(sb) {
        return sb.helpers.getPropertyObjectProperty;
    }
    setObjectDataProperty(sb) {
        return sb.helpers.setDataPropertyObjectProperty;
    }
}

//# sourceMappingURL=PickPropertyObjectPropertiesHelper.js.map
